import { createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";

import rootMiddleware from "@/middlewares";
import { initialState, rootReducer } from "@/redux/reducers";

const persistedReducer = persistReducer(initialState, rootReducer);

export const store = createStore(persistedReducer, rootMiddleware);

export const persistor = persistStore(store);
